import * as z from "zod";

const RecoverAutomationDomainSchema = z.object({
  exists: z.boolean(),
  discountId: z.string().nullable(),
  guidance: z.string(),
});

export const getRecoverOnboardingDomain = {
  name: "getRecoverOnboardingDomain" as const,
  input: z.object({}),
  output: z.object({
    automations: z.object({
      checkout_abandonment: RecoverAutomationDomainSchema,
      cart_abandonment: RecoverAutomationDomainSchema,
    }),
    integrations: z.object({
      attentive: z.boolean(),
      klaviyo: z.boolean(),
      postscript: z.boolean(),
    }),
    tenDlcStarted: z.boolean(),
  }),
};
